import config from '../misc/Configuracao';
import { IFiltroRapido } from "../modelo/FiltroRapido";
import { AxiosResponse } from "axios";
import fetch from './AxiosAdapter';

class FiltrosRapidosApi {

    private extrairLista(payload: any): any[] {
        if (!payload) {
            return [];
        }

        if (Array.isArray(payload)) {
            return payload;
        }

        const candidatos = [
            payload.content,
            payload.data,
            payload.result,
            payload.resultado,
            payload.items,
            payload.lista,
            payload.filtros,
            payload._embedded?.filtros,
            payload._embedded?.content
        ];

        for (const candidato of candidatos) {
            if (Array.isArray(candidato)) {
                return candidato;
            }
        }

        return [];
    }

    private normalizarFiltro(filtro: any): IFiltroRapido {
        const bruto = filtro?.filtroRapido || filtro?.filtro || filtro?.value || filtro;
        const filtroNormalizado: IFiltroRapido = { ...bruto };

        if (typeof filtroNormalizado?.dados === 'string') {
            try {
                filtroNormalizado.dados = JSON.parse(String(filtroNormalizado.dados));
            } catch {
                filtroNormalizado.dados = [];
            }
        }

        return filtroNormalizado;
    }

    private async tentarRecuperarFiltros(url: string): Promise<IFiltroRapido[]> {
        const result: AxiosResponse<any> = await fetch(url);
        const lista = this.extrairLista(result?.data);
        return (lista || []).map((filtro: any) => this.normalizarFiltro(filtro));
    }

    //MANTEM
    async recuperarFiltrosDoUsuario(cpf, gabinete, local?: string): Promise<IFiltroRapido[]> {
        const sufixo = cpf + "/" + gabinete + (local ? '?localDoFiltro=' + local : '');
        const urls = [
            config.urlFiltrosRapidosGE + sufixo
        ];

        let ultimoErro: any;
        for (const url of urls) {
            try {
                const filtros = await this.tentarRecuperarFiltros(url);
                if (filtros.length > 0) {
                    return filtros;
                }
            } catch (e) {
                ultimoErro = e;
            }
        }

        if (ultimoErro) {
            throw ultimoErro;
        }

        return [];

    }

    //MANTEM
    async excluirFiltro(idFiltro) {
        const result: AxiosResponse = await fetch(config.urlFiltrosRapidosGE + idFiltro, { method: 'DELETE' });
        if (result.status === 404) {
            throw new Error('Filtro não existe.');
        }
        return result;
    }

    //MANTEM
    async salvarNovoFiltro(filtro: IFiltroRapido) {
        return await fetch(config.urlFiltrosRapidosGE, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: filtro
        });
    }

    async alterarFiltro(filtro: IFiltroRapido): Promise<IFiltroRapido> {
        const result = await fetch<IFiltroRapido>(config.urlFiltrosRapidosGE + 'alterar', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: filtro
        });
        return result.data;
    }
}

export default new FiltrosRapidosApi();
